var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLibrary = function SvgLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 12,
    fill: "none",
    viewBox: "0 0 23 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#65350F",
    d: "M13.548 11.998h1.313c.002-4.466 3.648-8.08 8.138-8.08L23 .001C17.738.002 13.26 3.34 11.601 8h-.197C9.745 3.34 5.266 0 0 0L0 3.916c4.494 0 8.14 3.614 8.143 8.075h.566V12h4.84z"
  })));
};
export default SvgLibrary;